import { useEffect, useState } from 'react';

import { strings } from '../strings';
import type { Station } from '../types/station';
import { fetchStations } from '../utils/stations';

export const useStations = () => {
  const [stations, setStations] = useState<Station[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    fetchStations()
      .then(fetchedStations => {
        if (!isMounted) {
          return;
        }

        setStations(fetchedStations);
        setIsLoading(false);
      })
      .catch(caughtError => {
        if (!isMounted) {
          return;
        }

        console.error('Failed to fetch stations', caughtError);
        setError(strings.unableToLoadStations);
        setIsLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return { stations, isLoading, error };
};